/**
 * @generated SignedSource<<773e575701771f274ca312a99f2d1d18>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type WorkSuggestionsVulnerabilityStatus = "CLOSED" | "IGNORED" | "OPEN" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type criticalVulnerability_periscope_SecurityVulnerabilityTask$data = {
  readonly __typename: "WorkSuggestionsCriticalVulnerabilityTask";
  readonly id: string;
  readonly introducedDate: string;
  readonly issueKey: string;
  readonly securityContainerName: string;
  readonly status: WorkSuggestionsVulnerabilityStatus;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "criticalVulnerability_periscope_SecurityVulnerabilityTask";
};
export type criticalVulnerability_periscope_SecurityVulnerabilityTask$key = {
  readonly " $data"?: criticalVulnerability_periscope_SecurityVulnerabilityTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"criticalVulnerability_periscope_SecurityVulnerabilityTask">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "criticalVulnerability_periscope_SecurityVulnerabilityTask",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "issueKey"
    },
    {
      "kind": "ScalarField",
      "name": "securityContainerName"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "introducedDate"
    }
  ],
  "type": "WorkSuggestionsCriticalVulnerabilityTask"
};

(node as any).hash = "655adc301d60e3f9a7dec5e8b94c032f";

export default node;
